import I18n from 'I18n';
export const getDisabledTooltipTitle = ({
  isRecordCreatorEnabled,
  translationOptions
}) => {
  return isRecordCreatorEnabled ? I18n.text('indexPage.objectCreateButton.errors.noPermissions') : I18n.text('indexPage.objectCreateButton.errors.disabled', translationOptions);
};